<template>
    <el-drawer title="添加免检证件" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
        @close="close" append-to-body>
        <div class="drawer-content">
            <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">
                <el-form-item prop="documentName" label="名称：">
                    <el-input v-model="formData.documentName" placeholder="请输入姓名" :maxlength="40"></el-input>
                </el-form-item>
                <el-form-item prop="documentNumber" label="证件：">
                    <el-input v-model="formData.documentNumber" class="input-with-select"
                        style="display: inline-table;">
                        <el-select v-model="formData.documentType" slot="prepend" placeholder="请选择">
                            <el-option label="身份证" :value="1"></el-option>
                            <el-option label="港澳居民来往内地通行证" :value="2"></el-option>
                            <el-option label="台湾居民来往大陆通行证" :value="3"></el-option>
                            <el-option label="护照" :value="4"></el-option>
                            <el-option label="外国人永久居留身份证" :value="5"></el-option>
                            <el-option label="港澳台居民居住证" :value="6"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item prop="photoUrl" label="照片留底：">
                    <image-upload :url.sync="formData.photoUrl" :urlFull.sync="formData.photoUrl"
                        @onSuccess="handleSuccess"><span slot="size">无特殊要求</span></image-upload>
                    <div class="form-tips">请上传用户手持对应证件照片以便留底（要求能看清楚证件内容）</div>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">提交</el-button>
        </div>
    </el-drawer>
</template>

<script>
import ImageUpload from '@/components/ImageUpload';
const defaultFormData = {
    documentName: "",
    documentNumber: "",
    documentType: 1,
    photoUrl: ""
}
export default {
    components: {
        ImageUpload,
    },
    data() {
        return {
            drawerShow: false,
            btnLoading: false,
            formData: {
                ...defaultFormData
            },
            rules: {
                documentName: [{ required: true, message: "请输入姓名" }],
                documentNumber: [{ required: true, message: "请输入证件号码" }],
                photoUrl: [{ required: true, message: "请上传清晰的用户手持证件照片" }],
            }
        }
    },
    methods: {
        close() {
            this.formData = { ...defaultFormData };
            this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show() {
            this.drawerShow = true;
        },
        handleSuccess() {
            this.$refs["formData"].clearValidate('photoUrl');
        },
        //表单提交
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: "/commonPerformer/exemptAdd",
                        params: { ...this.formData },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('update');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            })
        }
    }
}
</script>

<style></style>